<template>
  <svg
    width="459"
    height="487"
    viewBox="0 0 459 487"
    fill="none"
    xmlns="http://www.w3.org/2000/svg"
  >
    <g clip-path="url(#clip0_3275_39531)">
      <mask
        id="mask0_3275_39531"
        style="mask-type: alpha"
        maskUnits="userSpaceOnUse"
        x="55"
        y="62"
        width="349"
        height="425"
      >
        <path
          d="M229.496 62.5908C283.269 62.5908 326.86 106.182 326.86 159.954L326.861 170.675C336.728 172.331 344.246 180.912 344.246 191.25V215.591C344.246 226.114 336.456 234.817 326.328 236.248C322.736 270.682 301.194 299.779 271.225 314.016L271.224 345.989H278.178C347.314 345.989 403.36 402.034 403.36 471.17V486.818H55.6328V471.17C55.6328 402.034 111.679 345.989 180.815 345.989H187.769L187.769 314.017C157.8 299.78 136.257 270.683 132.663 236.248C122.537 234.817 114.746 226.114 114.746 215.591V191.25C114.746 180.912 122.265 172.33 132.133 170.675L132.133 159.954C132.133 106.182 175.724 62.5908 229.496 62.5908Z"
          fill="#D08B5B"
        />
      </mask>
      <g mask="url(#mask0_3275_39531)">
        <path
          d="M229.496 62.5908C283.269 62.5908 326.86 106.182 326.86 159.954L326.861 170.675C336.728 172.331 344.246 180.912 344.246 191.25V215.591C344.246 226.114 336.456 234.817 326.328 236.248C322.736 270.682 301.194 299.779 271.225 314.016L271.224 345.989H278.178C347.314 345.989 403.36 402.034 403.36 471.17V486.818H55.6328V471.17C55.6328 402.034 111.679 345.989 180.815 345.989H187.769L187.769 314.017C157.8 299.78 136.257 270.683 132.663 236.248C122.537 234.817 114.746 226.114 114.746 215.591V191.25C114.746 180.912 122.265 172.33 132.133 170.675L132.133 159.954C132.133 106.182 175.724 62.5908 229.496 62.5908Z"
          :fill="body"
        />
        <path
          fill-rule="evenodd"
          clip-rule="evenodd"
          d="M132.133 226.023C132.133 279.795 175.724 323.386 229.496 323.386C283.269 323.386 326.86 279.795 326.86 226.023V239.932C326.86 293.704 283.269 337.295 229.496 337.295C175.724 337.295 132.133 293.704 132.133 239.932V226.023Z"
          fill="black"
          fill-opacity="0.1"
        />
      </g>
      <mask
        id="mask1_3275_39531"
        style="mask-type: alpha"
        maskUnits="userSpaceOnUse"
        x="196"
        y="255"
        width="67"
        height="34"
      >
        <path
          d="M196.666 259.279C198.505 275.781 212.502 288.613 229.495 288.613C246.541 288.613 260.571 275.702 262.341 259.126C262.483 257.792 260.993 255.579 259.126 255.579C233.231 255.579 213.392 255.579 200.089 255.579C198.211 255.579 196.482 257.628 196.666 259.279Z"
          fill="white"
        />
      </mask>
      <g mask="url(#mask1_3275_39531)">
        <path
          d="M196.666 259.279C198.505 275.781 212.502 288.613 229.495 288.613C246.541 288.613 260.571 275.702 262.341 259.126C262.483 257.792 260.993 255.579 259.126 255.579C233.231 255.579 213.392 255.579 200.089 255.579C198.211 255.579 196.482 257.628 196.666 259.279Z"
          fill="black"
          fill-opacity="0.7"
        />
        <path
          fill-rule="evenodd"
          clip-rule="evenodd"
          d="M212.111 236.454H248.623C253.424 236.454 257.316 240.346 257.316 245.147V255.579C257.316 260.38 253.424 264.272 248.623 264.272H212.111C207.31 264.272 203.418 260.38 203.418 255.579V245.147C203.418 240.346 207.31 236.454 212.111 236.454Z"
          fill="white"
        />
        <path
          d="M220.809 312.954C231.371 312.954 239.934 304.391 239.934 293.829C239.934 283.266 231.371 274.704 220.809 274.704C210.246 274.704 201.684 283.266 201.684 293.829C201.684 304.391 210.246 312.954 220.809 312.954Z"
          fill="#FF4F6D"
        />
        <path
          d="M238.195 312.954C248.758 312.954 257.32 304.391 257.32 293.829C257.32 283.266 248.758 274.704 238.195 274.704C227.633 274.704 219.07 283.266 219.07 293.829C219.07 304.391 227.633 312.954 238.195 312.954Z"
          fill="#FF4F6D"
        />
      </g>
      <path
        fill-rule="evenodd"
        clip-rule="evenodd"
        d="M208.637 226.022C208.637 233.704 217.978 239.932 229.5 239.932C241.023 239.932 250.364 233.704 250.364 226.022"
        fill="black"
        fill-opacity="0.16"
      />
      <path
        d="M184.291 205.159C190.053 205.159 194.723 200.488 194.723 194.727C194.723 188.965 190.053 184.295 184.291 184.295C178.53 184.295 173.859 188.965 173.859 194.727C173.859 200.488 178.53 205.159 184.291 205.159Z"
        :fill="eyes"
      />
      <path
        d="M274.701 205.159C280.463 205.159 285.133 200.488 285.133 194.727C285.133 188.965 280.463 184.295 274.701 184.295C268.94 184.295 264.27 188.965 264.27 194.727C264.27 200.488 268.94 205.159 274.701 205.159Z"
        :fill="eyes"
      />
      <path
        d="M159.308 172.4C166.115 162.823 184.775 157.452 200.849 161.399C202.714 161.857 204.597 160.717 205.055 158.851C205.513 156.986 204.372 155.103 202.507 154.645C183.84 150.061 162.232 156.28 153.639 168.371C152.527 169.937 152.894 172.108 154.459 173.22C156.025 174.333 158.196 173.966 159.308 172.4Z"
        :fill="eyeBrow"
      />
      <path
        d="M299.684 172.4C292.878 162.823 274.217 157.452 258.143 161.399C256.278 161.857 254.395 160.717 253.937 158.851C253.479 156.986 254.62 155.103 256.485 154.645C275.152 150.061 296.76 156.28 305.353 168.371C306.465 169.937 306.098 172.108 304.533 173.22C302.967 174.333 300.797 173.966 299.684 172.4Z"
        :fill="eyeBrow"
      />
      <path
        d="M210.928 33.6829C214.818 32.0778 217.658 33.7471 220.518 35.4824L221.265 35.9345C223.512 37.2825 225.829 38.5001 228.726 38.0492C233.75 37.2675 235.106 36.6291 239.639 39.4872C244.04 42.2612 245.085 40.2781 250.068 40.2384C253.588 40.2119 255.745 43.1535 258.69 43.4603C260.158 43.614 261.564 42.0839 263.14 42.1801C268.769 42.5214 269.125 49.7999 273.596 51.8038C277.682 53.6349 282.486 51.0623 286.54 50.5863C293.088 49.8179 292.335 53.6049 291.158 57.853L290.919 58.7075C290.384 60.6148 289.856 62.5592 289.938 64.1813C293.822 65.0874 297.763 61.4626 301.629 62.1297C307.23 63.0968 305.733 68.5142 304.359 72.6869L304.181 73.2236C304.123 73.3999 304.065 73.5733 304.008 73.7434C308.226 73.6674 319.238 68.9851 321.971 74.9736C323.38 78.0614 320.097 82.1836 320.15 85.3226C320.226 89.7413 323.472 93.3972 324.621 97.5793C326.172 103.225 328.381 118.356 324.495 123.368C323.198 125.041 314.34 120.344 310.646 118.304C279.619 101.161 273.596 95.7097 224.713 96.4211C175.83 97.1325 142.34 120.036 140.456 122.378C139.145 124.008 137.472 128.36 136.096 140.483C135.716 143.833 135.575 147.917 135.465 152.073L135.419 153.857C135.157 164.166 134.904 174.338 131.496 174.32C129.079 174.307 127.74 160.873 127.374 146.286L127.339 144.746L127.311 143.202L127.291 141.655C127.288 141.397 127.285 141.139 127.283 140.882L127.273 139.338C127.272 139.081 127.271 138.824 127.271 138.568L127.271 137.033C127.293 129.131 127.596 121.652 128.163 116.569C128.444 114.052 129.527 109.549 128.743 107.284C128.058 105.306 124.706 105.31 125.241 102.015C125.606 99.7638 127.114 99.5342 128.617 99.3233L129.117 99.2509C129.944 99.1223 130.73 98.9307 131.279 98.3328C134.399 94.9348 129.586 94.1306 128.788 91.1579C127.771 87.3705 130.145 85.9921 132.789 84.7968L134.12 84.2041C137.538 82.6614 137.094 84.0165 139.869 80.9943C136.163 78.2778 134.822 74.577 139.897 72.5916C142.052 71.7482 147.659 72.8644 149.347 71.5974C149.788 71.267 149.962 69.3731 150.233 68.9857C152.929 65.1283 152.264 62.3358 151.991 58.0052C151.766 54.4615 151.796 51.2085 156.039 50.8545C158.87 50.6185 161.172 52.9314 163.709 53.6124C166.523 54.3683 165.466 54.9197 167.671 53.4023C171.541 50.7365 168.907 45.5424 171.976 42.4437C176.188 38.1914 178.949 44.4245 182.331 44.8948C186.825 45.5211 187.685 42.9692 188.673 40.269L188.874 39.7279C189.453 38.1942 190.154 36.6778 191.662 35.7299C194.432 33.9898 195.868 35.2189 197.097 36.7838L197.401 37.1805C197.451 37.2473 197.501 37.3143 197.551 37.3812L197.849 37.7818C198.643 38.8421 199.45 39.8079 200.604 39.8988C203.415 40.1192 208.478 34.6938 210.928 33.6829ZM311.22 124.025C312.689 122.223 314.115 123.269 315.907 123.99C317.846 124.772 322.752 128.343 323.095 128.535C326.151 130.254 328.57 147.485 328.687 154.074C328.76 158.14 328.825 173.645 324.525 172.304C323.216 171.896 321.218 163.688 320.934 158.884C320.649 154.08 317.92 137.735 313.733 130.215C312.776 128.496 310.037 125.479 311.22 124.025Z"
        :fill="hair"
      />
      <g clip-path="url(#clip1_3275_39531)">
        <path
          d="M416.82 474.846V491.116H53.1836V474.846C53.1836 409.549 100.991 355.418 163.512 345.545C165.155 354.765 169.76 363.524 177.249 370.277L230.131 417.966C232.899 420.462 237.105 420.462 239.872 417.966L292.754 370.277C293.528 369.58 294.277 368.854 294.999 368.103C301.208 361.639 305.032 353.758 306.491 345.549C369.014 355.419 416.82 409.55 416.82 474.846Z"
          :fill="tshirt"
        />
      </g>
    </g>
    <defs>
      <clipPath id="clip0_3275_39531">
        <rect width="459" height="486.818" fill="white" />
      </clipPath>
      <clipPath id="clip1_3275_39531">
        <rect
          width="480"
          height="200"
          fill="white"
          transform="translate(-5 291)"
        />
      </clipPath>
    </defs>
  </svg>
</template>

<script lang="ts">
import { defineComponent } from "vue";

export default defineComponent({
  name: "High1",
  props: {
    body: String,
    eyes: String,
    eyeBrow: String,
    hair: String,
    tshirt: String
  },
});
</script>

